module.exports = __webpack_public_path__ + "img/ky.58b6db25.svg";